<button
  *ngIf="widgetConfig && (this.overlayActive === true || this.overlay === false)"
  class="pointer-events-none webkit-tap-highlight-color-transparent"
  [ngClass]="pageConfig?.isUsingHtmlStructure ? 'w-100' : 'forward-widget-button'"
  [ngStyle]="contentStyle"
  (click)="handleAction()"
  [disabled]="false"
>
  <mat-icon *ngIf="icon !== null && icon !== ''" [svgIcon]="icon" [ngStyle]="iconSize"></mat-icon>
  <span [innerHTML]="renderedContent"></span>
</button>
